import {Component, EventEmitter, Input, OnInit, Output, ViewChild,} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserService} from 'src/app/shares/services/user.service';
import {UserGroupService} from 'src/app/shares/services/user-group.service';
import {GlobalsService, TranslateHelpersService,} from 'src/app/shares/helpers';
import {ResponseResult} from 'src/app/shares/interfaces';
import {Action, FarmModelOptions, Gender, ImageType, Lang, StatusCode} from 'src/app/shares/constants';
import {AddressService, CategoryService} from 'src/app/shares/services';
import {Md5} from 'ts-md5/dist/md5';
import {DatePipe} from '@angular/common';
import {SocialAspectComponent} from './social-aspect/social-aspect.component';
import {EconomicAspectComponent} from './economic-aspect/economic-aspect.component';
import {ConserveEcologyComponent} from './conserve-ecology/conserve-ecology.component';
import {SeedingProgramComponent} from './seeding-program/seeding-program.component';
import {TrainningComponent} from './training/trainning.component';
import {WorkerSafetyComponent} from './worker-safety/worker-safety.component';
import {BrandIdentificationComponent} from './brand-identification/brand-identification.component';

@Component({
    selector: 'app-user-data-detail',
    templateUrl: './user-data-detail.component.html',
    styleUrls: ['./user-data-detail.component.scss'],
})
export class UserDataDetailComponent implements OnInit {
    @ViewChild(SocialAspectComponent, {static: false})
    socialAspectComponent: SocialAspectComponent;
    @ViewChild(EconomicAspectComponent, {static: false})
    economicAspectComponent: EconomicAspectComponent;
    @ViewChild(ConserveEcologyComponent, {static: false})
    conserveEcologyComponent: ConserveEcologyComponent;
    @ViewChild(SeedingProgramComponent, {static: false})
    seedingProgramComponent: SeedingProgramComponent;
    @ViewChild(TrainningComponent, {static: false})
    trainningComponent: TrainningComponent;
    @ViewChild(WorkerSafetyComponent, {static: false})
    workerSafetyComponent: WorkerSafetyComponent;
    @ViewChild(BrandIdentificationComponent, {static: false})
    brandIdentificationComponent: BrandIdentificationComponent;

    dateFormat = 'dd/MM/yyyy';
    formGroup: FormGroup;
    isShowForm = false;
    type = '';
    model: any;
    formTabData: any;
    dataFilter: any;
    password = '';
    configImage: any = {colIn: 12, colIm: 12};
    hideLeader: boolean;
    hideFermenter: boolean;
    lang: any;
    isAgronomist = false;
    mainId?: number = null;
    showTab = false;
    tabTitle: string;
    passwordVisible = false;

    farmModelOptions = FarmModelOptions;
    gender = Gender;

    @Input() configDetail: any;
    @Output() eventAction = new EventEmitter<any>();

    constructor(
        private fb: FormBuilder,
        private userService: UserService,
        private addressService: AddressService,
        private userGroupService: UserGroupService,
        private translate: TranslateHelpersService,
        private globals: GlobalsService,
        private datepipe: DatePipe,
        private categoryService: CategoryService
    ) {
        this.model = {};
        this.dataFilter = {};
        this.lang = Lang;
    }

    ngOnInit() {
        this.buildForm();
    }

    editData(
        data,
        hideLeader: boolean = false,
        groupId: number = 0,
        leaderId: number = 0,
        hideFermenter: boolean = true
    ) {
        this.hideLeader = !hideLeader;
        this.hideFermenter = !hideFermenter;
        this.model = data;
        if (data == null) {
            this.model = {};
            if (leaderId > 0) {
                this.model.leaderId = leaderId;
            }
            this.type = Action.Create;
        } else {
            this.type = Action.Edit;
            this.getUserDetail();
            this.getFarmerInfoDetail();
        }
        if (groupId > 0) {
            this.model.userGroupId = groupId;
        }

        this.isShowForm = false;
        this.dataFilter = {};
        this.model.countryId = 237;
        if (this.type === Action.Create) {
            this.getProvinces(this.model.countryId);
        }
        this.getUserGroups();
        this.getUserAgronomistsV2();
        this.getFarmerTypes();
        this.getUserFermenters();
        this.getFermenterTypes();
        this.getCategories();
        this.getUserSources();
        setTimeout(() => {
            this.buildForm();
            this.isShowForm = true;
        });

        if (groupId === 0 || groupId === 2) {
            this.showTab = true;
        }

        this.tabTitle = this.getTabTitle(groupId);
    }

    getTabTitle(userGroup: number): string {
        if (userGroup === 0) {
            return 'farmerForm.farmerInfo';
        }
        // Add more conditions as needed
    }

    getUserDetail() {
        this.globals.showLoading();
        this.userService.getDetailWithPartnerId(this.model.userId).subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();
                if (res.statusCode === StatusCode.Status200OK) {
                    this.model = res.data;
                    const datadt = {...this.model};
                    this.password = datadt.passWord;
                    this.model.image = ImageType + this.model.image;
                    this.model.countryId = 237;
                    this.model.farmerType = res.data.userType;
                    this.getProvinces(this.model.countryId);
                    this.buildForm();
                    this.isShowForm = true;
                } else {
                    this.globals.getErrorMessage(res.message);
                }
            },
            (error) => {
                this.globals.getError();
                this.globals.hideLoading();
            }
        );
    }

    buildForm() {
        this.formGroup = this.fb.group({
            userCode: [this.model.userCode, [Validators.required]],
            userName: [this.model.userName, []],
            fullName: [this.model.fullName, [Validators.required]],
            agronomistId: [this.model.agronomistId, []],
            fermenterId: [this.model.fermenterId, []],
            sourcingId: [this.model.sourcingId, []],
            email: [this.model.email, [Validators.email]],
            address: [this.model.address, []],
            subDistrict: [this.model.subDistrict, []],
            danToc: [this.model.danToc, []],
            countryId: [this.model.countryId, []],
            provinceId: [this.model.provinceId, []],
            districtId: [this.model.districtId, []],
            wardId: [this.model.wardId, []],
            userImportId: [this.model.userImportId, []],
            phoneNumber: [this.model.phoneNumber, []],
            passWord: [null, []],
            nameMarriage: [this.model.nameMarriage, []],
            identity: [this.model.identity, []],
            note: [this.model.note, []],
            gender: [this.model.gender, []],
            birthYear: [this.model.birthYear, []],
            joinDate: [this.model.joinDate, []],
            userType: [this.model.userType, []],
            productCategoryId: [this.model.productCategoryId, []],
            latitude: [this.model.latitude, []],
            longitude: [this.model.longitude, []],
            locate: [this.model.latitude + '-' + this.model.longitude, []],
            farmModel: [this.model.farmModel, []],
            growthYear: [this.model.growthYear],
            area: [this.model.area],
            numberMatureTrees: [this.model.numberMatureTrees, []],
        });
    }

    open(): void {
        this.configDetail.visible = true;
    }

    close(): void {
        this.configDetail.visible = false;
        this.showTab = false;
    }

    getResultImage($event) {
        this.model.image = $event.image;
    }

    getUserGroups() {
        this.globals.showLoading();
        this.userGroupService.getAll().subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();
                if (res.statusCode === StatusCode.Status200OK) {
                    this.dataFilter.userGroups = res.data.items;
                } else {
                    this.globals.getErrorMessage(res.message);
                }
            },
            (error) => {
                this.globals.getError();
                this.globals.hideLoading();
            }
        );
    }

    getUserAgronomistsV2() {
        this.globals.showLoading();
        this.userService.getByUserGroupId(17, 0).subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();
                if (res.statusCode === StatusCode.Status200OK) {
                    this.dataFilter.userAgronomists = res.data.items;
                    // if (this.type === Action.Create && (!this.model.AgronomistId || this.model.AgronomistId == 0)) {
                    //   // this.formGroup.controls["agronomistId"].setValue(res.data.items[0].userId);
                    // }
                    // setTimeout(() => {
                    //   if (this.type === Action.Create && this.model.AgronomistId && this.model.AgronomistId > 0) {
                    //     // this.formGroup.controls["agronomistId"].setValue(Number(this.model.AgronomistId));
                    //   }
                    // }, 1);
                } else {
                    this.dataFilter.userAgronomists = [];
                }
            },
            (error) => {
                this.globals.getError();
                this.globals.hideLoading();
            }
        );
    }

    getUserFermenters() {
        this.globals.showLoading();
        this.userService.getByUserGroupId(11, 0).subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();
                if (res.statusCode === StatusCode.Status200OK) {
                    this.dataFilter.userFermenters = res.data.items;
                    // if (this.type === Action.Create && (!this.model.fermenterId || this.model.fermenterId == 0)) {
                    //   // this.formGroup.controls["fermenterId"].setValue(res.data.items[0].userId);
                    // }
                    // setTimeout(() => {
                    //   if (this.type === Action.Create && this.model.fermenterId && this.model.fermenterId > 0) {
                    //     // this.formGroup.controls["fermenterId"].setValue(Number(this.model.fermenterId));
                    //   }
                    // }, 1);
                } else {
                    this.dataFilter.userFermenters = [];
                }
            },
            (error) => {
                this.globals.getError();
                this.globals.hideLoading();
            }
        );
    }

    getUserSources() {
        this.globals.showLoading();
        this.userService.getByUserGroupId(6, 0).subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();
                if (res.statusCode === StatusCode.Status200OK) {
                    this.dataFilter.userUserSources = res.data.items;
                    if (
                        this.type === Action.Create &&
                        (!this.model.SourceId || this.model.SourceId === 0)
                    ) {
                        this.formGroup.controls.sourcingId.setValue(
                            res.data.items[0].userId
                        );
                    }
                    setTimeout(() => {
                        if (
                            this.type === Action.Create &&
                            this.model.SourceId &&
                            this.model.SourceId > 0
                        ) {
                            this.formGroup.controls.sourcingId.setValue(
                                Number(this.model.SourceId)
                            );
                        }
                    }, 1);
                } else {
                    this.dataFilter.userUserSources = [];
                }
            },
            (error) => {
                this.globals.getError();
                this.globals.hideLoading();
            }
        );
    }

    getProvinces(id: number, langId: string = '') {
        this.globals.showLoading();
        this.dataFilter.provinces = [];
        this.addressService.getProvinces(id, langId).subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();
                if (res.statusCode === StatusCode.Status200OK) {
                    this.dataFilter.provinces = res.data;
                } else {
                    this.globals.getErrorMessage(res.message);
                    this.globals.hideLoading();
                }
            },
            (error) => {
                this.globals.getError();
                this.globals.hideLoading();
            }
        );
    }

    getDistricts(id: number, langId: string = '') {
        this.dataFilter.districts = [];
        this.globals.showLoading();
        this.addressService.getDistricts(id, langId).subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();
                if (res.statusCode === StatusCode.Status200OK) {
                    this.dataFilter.districts = res.data;
                } else {
                    this.globals.hideLoading();
                    this.globals.getErrorMessage(res.message);
                }
            },
            (error) => {
                this.globals.hideLoading();
                this.globals.getError();
            }
        );
    }

    getWards(id: number, langId: string = '') {
        this.dataFilter.wards = [];
        this.globals.showLoading();
        this.addressService.getWards(id, langId).subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();
                if (res.statusCode === StatusCode.Status200OK) {
                    this.dataFilter.wards = res.data;
                    // if (this.model.wardId == null) {
                    //   this.model.wardId = this.dataFilter.wards[0].id;
                    // }
                } else {
                    this.globals.hideLoading();
                    this.globals.getErrorMessage(res.message);
                }
            },
            (error) => {
                this.globals.hideLoading();
                this.globals.getError();
            }
        );
    }

    getFarmerTypes() {
        this.dataFilter.farmerTypes = [
            {key: 1, value: 'Nông dân Marou'},
            {key: 2, value: 'Nông dân bán trái'},
            {key: 3, value: 'Dự án cây giống'},
        ];
    }

    getFermenterTypes() {
        this.dataFilter.fermenterTypes = [
            {key: 11, value: 'Lên men loại A'},
            {key: 12, value: 'Lên men loại B'},
        ];
    }

    getCategories() {
        this.globals.showLoading();
        this.dataFilter.categories = [];
        this.categoryService.CateGetAll(0).subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();
                if (res.statusCode === StatusCode.Status200OK) {
                    this.dataFilter.categories = res.data.items;
                } else {
                    this.dataFilter.categories = [];
                }
            },
            (error) => {
                this.globals.getError();
                this.globals.hideLoading();
            }
        );
    }

    changeLocation(type, $event) {
        if ($event != null) {
            switch (type) {
                case 'province':
                    if ($event !== this.model.provinceId) {
                        this.model.districtId = null;
                        this.model.wardId = null;
                    }
                    this.getDistricts($event, this.model.langId);
                    break;
                case 'district':
                    if ($event !== this.model.districtId) {
                        this.model.wardId = null;
                    }
                    this.getWards($event, this.model.langId);
                    break;
            }
        }
    }

    submitForm() {
        if (!this.formGroup.valid) {
            return;
        }
        this.convertObject(this.formGroup.value);
        if (this.model.image) {
            const Image = this.model.image.split('base64,');
            this.model.image = Image[1];
        }
        if (this.type === Action.Create) {
            const data = this.formGroup.value.passWord;
            this.model.passWord = Md5.hashStr(data);
            this.model.mainId = this.mainId;
            this.model.isAgronomist = this.isAgronomist;
            this.globals.showLoading();

            if (this.isAgronomist) {
                this.userService.createAgronomist(this.model).subscribe(
                    (res) => {
                        this.globals.hideLoading();
                        if (res.statusCode === StatusCode.Status200OK) {
                            this.globals.saveSuccess();
                            this.eventAction.emit({
                                event: Action.Create,
                                success: true,
                            });
                            this.close();
                        } else {
                            this.globals.getErrorMessage(res.message);
                        }
                    },
                    (error) => {
                        this.globals.hideLoading();
                        this.globals.saveError();
                    }
                );
            } else {
                this.model.joinDateStr = this.datepipe.transform(
                    this.model.joinDate,
                    'yyyy-MM-dd'
                );
                this.userService.createWithPartner(this.model).subscribe(
                    (res) => {
                        this.globals.hideLoading();
                        if (res.statusCode === StatusCode.Status200OK) {
                            this.globals.saveSuccess();
                            this.eventAction.emit({
                                event: Action.Create,
                                success: true,
                            });
                            this.close();
                        } else {
                            this.globals.getErrorMessage(res.message);
                        }
                    },
                    (error) => {
                        this.globals.hideLoading();
                        this.globals.saveError();
                    }
                );
            }
        } else {
            this.globals.showLoading();
            const data = this.formGroup.value.passWord;
            if (data !== null && this.password !== data) {
                this.model.passWord = Md5.hashStr(data);
            }
            this.model.joinDateStr = this.datepipe.transform(
                this.model.joinDate,
                'yyyy-MM-dd'
            );
            this.userService.updateWithPartner(this.model).subscribe(
                (res) => {
                    this.globals.hideLoading();
                    if (res.statusCode === StatusCode.Status200OK) {
                        this.globals.saveSuccess();
                        this.eventAction.emit({
                            event: Action.Create,
                            success: true,
                        });
                        this.close();
                    } else {
                        this.globals.getErrorMessage(res.message);
                    }
                },
                (error) => {
                    this.globals.hideLoading();
                    this.globals.saveError();
                }
            );
        }
        if (this.showTab) {
            this.submitAllForms();
        }
    }

    convertObject(data) {
        Object.keys(data).forEach((e) => {
            this.model[e] = data[e];
        });
    }

    changeUserImport($event) {
        const data = this.dataFilter.userImports.filter((c) => {
            return c.id === $event;
        });
        if (data.length > 0) {
            setTimeout(() => {
                const address = `${data[0].thon}, ${data[0].xa}, ${data[0].huyen}`;
                this.formGroup.controls.fullName.setValue(data[0].chuHo);
                this.formGroup.controls.danToc.setValue(data[0].danToc);
                this.formGroup.controls.subDistrict.setValue(data[0].tieuKhu);
                this.formGroup.controls.address.setValue(address);
                this.formGroup.controls.provinceId.setValue(data[0].provinceId);
                this.formGroup.controls.districtId.setValue(data[0].districtId);
                this.formGroup.controls.wardId.setValue(data[0].wardId);
                this.formGroup.controls.userCode.setValue(data[0].userCode);
            }, 1);
        }
    }

    // Update Agronomist
    editDataV2(
        data,
        hideLeader: boolean = false,
        groupId: number = 0,
        mainId: number = 0,
        isAgronomist: boolean = true
    ) {
        this.isAgronomist = isAgronomist;
        this.hideLeader = !hideLeader;
        this.mainId = mainId;
        this.model = data;
        if (data == null) {
            this.model = {};
            if (mainId > 0) {
                this.model.mainId = mainId;
            }
            this.type = Action.Create;
        } else {
            this.type = Action.Edit;
            this.getUserDetail();
        }

        if (groupId > 0) {
            this.model.userGroupId = groupId;
        }

        this.isShowForm = false;
        this.dataFilter = {};
        this.model.countryId = 237;
        if (this.type === Action.Create) {
            this.getProvinces(this.model.countryId);
        }
        this.getUserGroups();
        this.getUserAgronomists();
        this.getUserFermenters();
        // this.getUserImports();

        setTimeout(() => {
            this.buildForm();
            this.isShowForm = true;
        });
    }

    getUserAgronomists() {
        this.globals.showLoading();
        this.userService.getByUserByRole(11).subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();

                if (res.statusCode === StatusCode.Status200OK) {
                    this.dataFilter.userLeaders = res.data.items;
                    if (
                        this.type === Action.Create &&
                        (!this.model.leaderId || this.model.leaderId === 0)
                    ) {
                        this.model.leaderId = res.data.items[0].userId;
                        this.formGroup.controls.leaderId.setValue(res.data.items[0].userId);
                    }
                    setTimeout(() => {
                        if (
                            this.type === Action.Create &&
                            this.model.leaderId &&
                            this.model.leaderId > 0
                        ) {
                            this.formGroup.controls.leaderId.setValue(
                                Number(this.model.leaderId)
                            );
                        }
                    }, 1);
                } else {
                    this.dataFilter.userLeaders = [];
                    // this.globals.getErrorMessage(res.message);
                }
            },
            (error) => {
                this.globals.getError();
                this.globals.hideLoading();
            }
        );
    }

    submitAllForms() {
        const userId = this.model.userId;
        // Collect data from your components
        const socialAspectData = JSON.stringify(
            this.socialAspectComponent.submitForm()
        );

        const economicAspectData = JSON.stringify(
            this.economicAspectComponent.submitForm()
        );
        const conserveEcologyData = JSON.stringify(
            this.conserveEcologyComponent.submitForm()
        );
        const seedingProgramData = JSON.stringify(
            this.seedingProgramComponent.submitForm()
        );
        const trainningData = JSON.stringify(this.trainningComponent.submitForm());
        const brandIdentificationData = JSON.stringify(
            this.brandIdentificationComponent.submitForm()
        );
        const workerSafetyData = JSON.stringify(
            this.workerSafetyComponent.submitForm()
        );

        this.formTabData = {
            userId,
            phuongDienXaHoi: socialAspectData,
            baoTonHeSinhThai: conserveEcologyData,
            anToanSucKhoe: workerSafetyData,
            khiaCanhKinhTe: economicAspectData,
            nhanDienThuongHieu: brandIdentificationData,
            chuongTrinhCayGiong: seedingProgramData,
            daoTao: trainningData,
        };

        this.userService
            .updateFarmerInfo(this.formTabData)
            .subscribe((response) => {
                if (response.statusCode === StatusCode.Status200OK) {
                    this.globals.saveSuccess();
                    this.close();
                } else {
                    this.globals.getErrorMessage(response.message);
                }
            });
    }

    getFarmerInfoDetail() {
        this.globals.showLoading();
        this.formTabData = {};
        this.userService.getDetailFarmerInfobyId(this.model.userId).subscribe(
            (res: ResponseResult) => {
                this.globals.hideLoading();
                if (res.statusCode === StatusCode.Status200OK) {
                    this.formTabData = res.data;
                    // this.buildForm();
                    this.isShowForm = true;
                } else {
                    this.globals.getErrorMessage(res.message);
                }
            },
            (error) => {
                this.globals.getError();
                this.globals.hideLoading();
            }
        );
    }
}
